var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"prepend-inner-icon":_vm.icon,"label":"POI Type","outlined":_vm.outlined,"item-text":"name","item-value":"id","items":_vm.items,"hide-details":""},on:{"change":_vm.onChange},model:{value:(_vm.selectedTypeId),callback:function ($$v) {_vm.selectedTypeId=$$v},expression:"selectedTypeId"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b4382ad","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/itineraries/routes/RoutePoiTypeSelect.vue
// module id = null
// module chunks = 